
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/naytasivu/[slug]",
      function () {
        return require("private-next-pages/naytasivu/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/naytasivu/[slug]"])
      });
    }
  